import { connect } 		from 'react-redux'
import Login 			from '../Login';
import {logInAction} 	from '../../actions/authActions'

const mapStateToProps = state => {
  return {
    account: state.account
  }
}

const mapDispatchToProps = dispatch => {
    return {
      logIn: (email, password) => {
        dispatch(logInAction(email, password))
      }
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/components/containers/LoginContainer.js